/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_TaskBudgetItemResponse_ } from '../models/PaginatedResponse_TaskBudgetItemResponse_';
import type { TaskBudgetItemCreateRequest } from '../models/TaskBudgetItemCreateRequest';
import type { TaskBudgetItemResponse } from '../models/TaskBudgetItemResponse';
import type { TaskBudgetItemsBulkUpdateRequest } from '../models/TaskBudgetItemsBulkUpdateRequest';
import type { TaskBudgetItemsBulkUpdateResponse } from '../models/TaskBudgetItemsBulkUpdateResponse';
import type { TaskBudgetItemUpdateRequest } from '../models/TaskBudgetItemUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TaskBudgetItemService {
    /**
     * Create Task Budget Item
     * 세부실행과제 예산 항목 생성
     *
     * 새로운 세부실행과제 예산 항목을 생성합니다.
     * @returns TaskBudgetItemResponse Created
     * @throws ApiError
     */
    public static appsTaskViewsCreateTaskBudgetItem({
        requestBody,
    }: {
        requestBody: TaskBudgetItemCreateRequest,
    }): CancelablePromise<TaskBudgetItemResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/task/budget/item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Task Budget Items
     * 세부실행과제 예산 항목 목록 조회 및 검색
     *
     * 세부실행과제 예산 항목을 페이징하여 조회하거나 키워드로 검색합니다.
     *
     * Args:
     * q: 검색 키워드 (선택사항)
     * task_budget_id: 세부실행과제 예산 ID로 필터링 (선택사항)
     * @returns PaginatedResponse_TaskBudgetItemResponse_ OK
     * @throws ApiError
     */
    public static appsTaskViewsListTaskBudgetItems({
        q,
        taskBudgetId,
        page = 1,
        perPage = 100,
    }: {
        q?: string,
        taskBudgetId?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_TaskBudgetItemResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/budget/item',
            query: {
                'q': q,
                'task_budget_id': taskBudgetId,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Task Budget Item
     * 세부실행과제 예산 항목 조회
     *
     * ID로 특정 예산 항목을 조회합니다.
     * @returns TaskBudgetItemResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsGetTaskBudgetItem({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<TaskBudgetItemResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/task/budget/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Budget Item
     * 세부실행과제 예산 항목 수정
     *
     * 특정 예산 항목의 정보를 수정합니다.
     * @returns TaskBudgetItemResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskBudgetItem({
        itemId,
        requestBody,
    }: {
        itemId: string,
        requestBody: TaskBudgetItemUpdateRequest,
    }): CancelablePromise<TaskBudgetItemResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/budget/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Task Budget Item
     * 세부실행과제 예산 항목 삭제
     *
     * 특정 예산 항목을 삭제합니다.
     * @returns void
     * @throws ApiError
     */
    public static appsTaskViewsDeleteTaskBudgetItem({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/task/budget/item/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Task Budget Items Bulk
     * 세부실행과제 예산 항목 벌크 업데이트
     *
     * 예산 항목들을 한 번에 생성/수정/삭제합니다.
     * - ID가 없는 항목: 새로 생성
     * - ID가 있는 항목: 기존 항목 수정
     * - 요청에 없는 기존 항목: 삭제 처리
     *
     * Args:
     * budget_id: 예산 ID
     * data: 벌크 업데이트 요청 데이터
     * - items: 업데이트할 예산 항목 목록
     * - id: 항목 ID (없으면 신규 생성)
     * - name: 예산 항목명
     * - target_figure: 목표 금액
     * - done_figure: 완료 금액
     *
     * Returns:
     * 200: 업데이트 결과 (생성/수정/삭제 개수 및 최종 항목 목록)
     * 400: 잘못된 요청 데이터
     * 401: 인증 실패
     * 404: 예산을 찾을 수 없음
     * 500: 서버 내부 오류
     * @returns TaskBudgetItemsBulkUpdateResponse OK
     * @throws ApiError
     */
    public static appsTaskViewsUpdateTaskBudgetItemsBulk({
        budgetId,
        requestBody,
    }: {
        budgetId: string,
        requestBody: TaskBudgetItemsBulkUpdateRequest,
    }): CancelablePromise<TaskBudgetItemsBulkUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/task/budget/{budget_id}/items',
            path: {
                'budget_id': budgetId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
